import { call, put, takeLatest, } from 'redux-saga/effects';
import { Urls } from 'src/common/urls';
import * as Actions from './action';
import * as ActionTypes from './actionTypes';
import { NetworkingProvider } from 'src/features/Security/networking/networkingProvider';
import { getErrorFromResponse } from 'src/features/Security/networking/util';
import { CashboxCategoriesFilters } from 'src/common/models/cashboxCategory';
import { IncomeRecordsFilters } from 'src/common/models/incomeRecord';

const buildQueryString = (filters?: CashboxCategoriesFilters) => {
    const filtersList: string[] = []
    if (filters?.type) {
        filtersList.push(`type=${filters.type}`)
    }

    return filtersList.length > 0
        ? `?${filtersList.join('&')}`
        : ``
}

function* getCashboxCategoriesApi(action: Actions.GetCashboxCategoriesAction) {
    try {
        const response = yield call(NetworkingProvider.getInstance().getControlInterface().get, Urls.BACKEND.CASHBOX_CATEGORY.GET_RECORDS(buildQueryString(action.filters)))
        yield put(Actions.getCashboxCategoriesApiSuccess(response.data))
    } catch (err) {
        yield put(Actions.getCashboxCategoriesApiError(getErrorFromResponse(err)));
    }
}

function* upsertCashboxCategoryApi(action: Actions.UpsertCashboxCategoryAction) {
    try {
        const response = yield call(NetworkingProvider.getInstance().getControlInterface().post, Urls.BACKEND.CASHBOX_CATEGORY.UPSERT, action.cashboxCategory)
        yield put(Actions.upsertCashboxCategoryApiSuccess(response.data))
    } catch (err) {
        yield put(Actions.upsertCashboxCategoryApiError(getErrorFromResponse(err)));
    }
}

function* createIncomeRecordApi(action: Actions.CreateIncomeRecordAction) {
    try {
        const response = yield call(NetworkingProvider.getInstance().getControlInterface().post, Urls.BACKEND.INCOME_RECORD.CREATE, action.incomeRecord)
        yield put(Actions.createIncomeRecordApiSuccess(response.data))
    } catch (err) {
        yield put(Actions.createIncomeRecordApiError(getErrorFromResponse(err)));
    }
}

const buildIncomeRecordsQueryString = (filters?: IncomeRecordsFilters): string => {
    const filtersList: string[] = []
    if (filters?.dateFrom && filters?.dateTo) {
        filtersList.push(`dateFrom=${filters.dateFrom}`)
        filtersList.push(`dateTo=${filters.dateTo}`)
    }

    return filtersList.length > 0
        ? `?${filtersList.join('&')}`
        : ``
}

function* getIncomeRecordsApi(action: Actions.GetIncomeRecordsAction) {
    try {
        const response = yield call(NetworkingProvider.getInstance().getControlInterface().get, Urls.BACKEND.INCOME_RECORD.GET_RECORDS(buildIncomeRecordsQueryString(action.filters)))
        yield put(Actions.getIncomeRecordsApiSuccess(response.data))
    } catch (err) {
        yield put(Actions.getIncomeRecordsApiError(getErrorFromResponse(err)));
    }
}

export default function* cashboxSagas() {
    yield takeLatest(ActionTypes.GET_CASHBOX_CATEGORIES_API, getCashboxCategoriesApi)
    yield takeLatest(ActionTypes.UPSERT_CASHBOX_CATEGORY_API, upsertCashboxCategoryApi)
    yield takeLatest(ActionTypes.CREATE_INCOME_RECORD_API, createIncomeRecordApi);
    yield takeLatest(ActionTypes.GET_INCOME_RECORDS_API, getIncomeRecordsApi);
}